import { defineStore } from 'pinia'

export const useUpgradeModalStore = defineStore('upgradeModal', {
  state: () => ({
    open: false
  }),
  actions: {
    openModal() {
      this.open = true
    },
    closeModal() {
      this.open = false
    },
    toggle() {
      this.open = !this.open
    }
  }
})
